import React from 'react'
import styles from './styles'
import { CircularProgress, withStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { EditorType } from 'src/model/card'
import CardSuneditor from 'src/components/card-suneditor'
import { DragDropEditor } from '../../../index'
import useCardData from 'src/hooks/useCardData'
import { LastPageHeader, ResultCardView } from '../index'
import { AnswerItemType } from 'src/model/card'
import BadgeCard from 'src/components/answer-type/badge'
const LastPageView = props => {
  const { classes, sections, setSections } = props
  const course = useSelector(state => state.course.course)
  const editorType = EditorType[course?.editorType]
  const lastCard = useSelector(state => state.course.endingCard)
  const { cardData, isLoading, isEndingCardExist } = useCardData()
  const isCardResultCard = cardData && cardData?.type === AnswerItemType.RESULT
  const isCardBadgeCard = cardData && cardData?.type === AnswerItemType.BADGE
  const processedCardData =
    cardData && cardData.type === 14 && !cardData.text
      ? {
          ...cardData,
          text:
            '<div class="simple-box-wrapper" style="background-position:center;background-size:cover;" background-image="" background-color="" background-type="" background-size="cover" size-type="SCALE_TO_FILL" use-image-overlay="" background-position="center" linear-value="" opacity="" overlay-color=""><div class="simple-box"><div class="column" flex-size="undefined"><p>Your Score: [{{Correct_Answers}} / {{Quiz_Questions}} * 100]%</p></div></div></div>',
        }
      : cardData
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {!isLoading && (
        <div className={classes.container}>
          <LastPageHeader
            sections={sections}
            setSections={setSections}
            cardData={cardData}
            isEndingCardExist={isEndingCardExist}
          />
          {isCardResultCard && (
            <ResultCardView
              cardData={cardData}
              isCardResultCard={isCardResultCard}
            />
          )}
          {isCardBadgeCard && <BadgeCard></BadgeCard>}
          {!isCardBadgeCard &&
            !isCardResultCard &&
            lastCard &&
            (editorType === 'Legacy' ? (
              <CardSuneditor />
            ) : lastCard?.id == cardData?.id ? (
              <DragDropEditor
                data={
                  cardData.type === 14 && cardData.text === null
                    ? processedCardData
                    : cardData
                }
                isLoading={isLoading}
              />
            ) : (
              <CircularProgress />
            ))}
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(LastPageView)
